<template>
  <section>
    <!-- :modal-append-to-body="false" -->
    <Drawer
      class="body-plp-drawer"
      :class="{ 'page-plp_drawer-mobile': isMobile }"
      title="筛选"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      :append-to-body="true"
      :modal-append-to-body="true"
    >
      <GtCollapse :value="activeList">
        <GtCollapseItem
          v-if="
            categoryList.list && categoryList.list.length && isShowCategoryCollapse && showTypeSide
          "
          title="产品分类"
          :name="categoryList.code"
          :class="{ foldOneLine2: fold.includes(categoryList.code) }"
          @click.native="handleClickCollapse(categoryList.code)"
        >
          <div
            class="fold-multi"
            :class="{ foldOneLine: fold.includes(categoryList.code) }"
            @click.stop="handleEventStop"
          >
            <!-- :option="packedCategoryList()" -->
            <!-- :option="categoryList.list[0].list" -->
            <PdtSizePicker
              v-model="bindValue"
              free-column
              :option="packedCategoryList()"
              multiple
              label-key="name"
              value-key="code"
              @change="changeCategory"
            />
          </div>
        </GtCollapseItem>
        <GtCollapseItem
          v-for="item in spuAttrList.filter(i => i.list && i.list.length)"
          :key="item.code"
          :title="item.name"
          :name="item.code"
          :class="{ foldOneLine2: fold.includes(item.code) }"
          @click.native="handleClickCollapse(item.code)"
        >
          <div
            class="fold-multi"
            :class="{ foldOneLine: fold.includes(item.code) }"
            @click.stop="handleEventStop"
          >
            <PdtSizePicker
              :free-column="item.code !== 'PDP_SEX'"
              :value="item.code === 'PDP_SEX' ? bindValue2 : item.bindValue"
              :option="item.list"
              multiple
              label-key="name"
              value-key="code"
              @input="
                newValue =>
                  item.code === 'PDP_SEX' ? (bindValue2 = newValue) : (item.bindValue = newValue)
              "
              @change="item.code === 'PDP_SEX' ? changeSex($event) : changeSpu($event, item)"
            />
          </div>
        </GtCollapseItem>
        <div v-if="priceRange[0] != priceRange[1] || showPriceRange">
          <div class="price-item">
            <span class="price-left">价格</span>
            <span class="price-right">{{ `¥${priceRange[0]} - ¥${priceRange[1]}` }}</span>
          </div>
          <div>
            <GtSlider
              ref="priceSliderRef"
              :key="sliderKey"
              v-model="priceRange"
              class="gt-plp-filter__optiontypes-slider"
              size="small"
              range
              :disabled="rangeOption.min === rangeOption.max"
              :min="rangeOption.min"
              :max="rangeOption.max"
              :show-tooltip="false"
              @change="val => onChange(priceRange, price)"
            ></GtSlider>
          </div>
          <div class="price-item-bottom">
            <span class="price-left">{{ `¥${rangeOption.min}` }}</span>
            <span class="price-right">{{ `¥${rangeOption.max}以上` }}</span>
          </div>
        </div>
        <GtCollapseItem
          v-if="colorList.list && colorList.list.length"
          title="颜色"
          :name="colorList.code"
          class="color-collapse-item"
          :class="{ foldOneLine2: fold.includes(colorList.code) }"
          @click.native="handleClickCollapse(colorList.code)"
        >
          <ul
            class="color-list fold-multi"
            :class="{ foldOneLine3: fold.includes(colorList.code) }"
            @click.stop="handleEventStop"
          >
            <li
              v-for="cell in colorList.list"
              :key="cell.code"
              class="color-list_item"
              :class="{
                active: selectedCodeList.includes(cell.code)
              }"
              :title="cell.valueName"
              @click="onChange(cell, colorList)"
            >
              <p
                :style="{
                  backgroundColor: cell.valueImage || cell.valueCode,
                  border: ['#FFFFFF', 'white'].includes(cell.valueImage || cell.valueCode)
                    ? '1px solid #dddddd'
                    : ''
                }"
                :class="cell.valueCode"
              ></p>
              <div
                v-if="selectedCodeList.includes(cell.code)"
                class="iconfont icon-check-line"
                :style="{
                  color: ['#FFFFFF', 'white'].includes(cell.valueImage || cell.valueCode)
                    ? '#14141E'
                    : ''
                }"
              ></div>
            </li>
          </ul>
        </GtCollapseItem>
        <GtCollapseItem
          class="size-collapse-item"
          title="尺码"
          :name="sizeList.code"
          :class="{ foldOneLine2: fold.includes(sizeList.code) }"
          @click.native="handleClickCollapse(sizeList.code)"
        >
          <div
            class="fold-multi"
            :class="{ foldOneLine: fold.includes(sizeList.code) }"
            @click.stop="handleEventStop"
          >
            <PdtSizePicker
              v-model="bindValue3"
              :option="sizeList.list"
              multiple
              label-key="name"
              value-key="code"
              @change="changeSize"
            />
          </div>
        </GtCollapseItem>
      </GtCollapse>
      <div class="drawer-bottom">
        <gt-button class="db-reset" @click="handleClearAll">重置</gt-button>
        <gt-button type="primary" class="db-confirm" @click="onChangeConfirm">确定</gt-button>
      </div>
    </Drawer>
  </section>
</template>

<script>
import {
  GtCollapse,
  GtCollapseItem,
  GtButton,
  componentsCommon,
  GtSlider
} from '@speedshop/template';
import { Drawer } from 'element-ui';
import { CatalogProduct, CatalogWcmProduct } from '@/utils/product';
import PdtSizePicker from '@/components/PDP/SizePicker.vue';
import 'animate.css';
import { scrollToTop } from '@/utils/dom';

export default {
  components: {
    GtCollapse,
    GtCollapseItem,
    GtButton,
    GtSlider,
    Drawer,
    PdtSizePicker
  },
  mixins: [componentsCommon],
  props: {
    totalCount: {},
    onFilter: {},
    filterData: {
      type: Array,
      default: () => []
    },
    resetFilterData: {},
    params: {},
    unidirectionSelectedDataStatus: {
      type: Boolean,
      default: false
    },
    showTypeSide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedData: {},
      sizeCode: 'SIZE',
      colorCode: 'PDP_COLOR_GROUP',
      priceRange: [1, 1],
      sliderKey: 1,
      timer: null,
      bindValue: [], // category
      bindValue2: [], // sex
      bindValue3: [], // size
      drawer: false,
      isShowCategoryCollapse: false,
      fold: [],
      showPriceRange: false
    };
  },
  computed: {
    selectedList() {
      let list = [];
      for (const key in this.selectedData) {
        if (key === 'PRICE' && this.selectedData[key].length) {
          const price = this.selectedData[key][0];
          list = [...list, [{ name: price.join('-'), parentCode: 'PRICE' }]];
        } else {
          list = [...list, this.selectedData[key]];
        }
      }
      const data = list;
      const result = data.reduce((result, item) => {
        return [...result, ...item];
      }, []);
      return result;
    },
    selectedCodeList() {
      return this.selectedList.map(i => i.code);
    },
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c.name || c.categoryName
                  };
                }),
                name: e.name || e.categoryName
              };
            }),
            name: i.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //       const matchChildren = i.list.some(c => {
      //         const pathCodeList = c.categoryPath?.split('>') || [];
      //         return filterCategory.some(e => {
      //           return pathCodeList.includes(e);
      //         });
      //       });
      //       return matchChildren;
      //     });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item.name,
              code: item.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    },
    skuAttrList() {
      return (
        this.filterData &&
        this.filterData.filter(i => i.attrCate === 'SKUATTR' && i.code !== this.sizeCode)
      );
    },
    spuAttrList() {
      const result =
        this.filterData &&
        this.filterData.filter(i => i.attrCate === 'SPUATTR' && i.code !== this.colorCode);
      const filterSex = result.filter(i => {
        if (i.code === 'PDP_SEX' && i.list.length === 1) {
          return false;
        } else {
          return true;
        }
      });
      return filterSex;
    },
    sizeList() {
      const list = this.filterData.find(i => i.code === this.sizeCode) || {};

      return list;
    },
    colorList() {
      const list = this.filterData.find(i => i.code === this.colorCode) || {};

      return list;
    },
    sortList() {
      return (this.filterData && this.filterData.find(i => i.code === 'SORT')) || {};
    },
    price() {
      return (this.filterData && this.filterData.find(i => i.code === 'PRICE')) || {};
    },
    tagList() {
      // return (this.filterData && this.filterData.find(i => i.code === 'TAG')) || {};
      // 写死tag
      return {
        attrCate: null,
        code: 'TAG',
        list: [
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '新品',
            displayName: '新品推荐',
            name: '新品推荐',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '新品',
            tagName: '新品推荐'
          },
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '热卖',
            displayName: '热卖商品',
            name: '热卖商品',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '热卖',
            tagName: '热卖商品'
          }
        ],
        name: 'Tag',
        type: 'CHECKBOX'
      };
    },
    activeList() {
      return this.filterData && this.filterData.map(i => i.code);
    },
    rangeOption() {
      const { list = [] } = this.price || {};
      const { max = 0, min = 0 } = (list.length && list[0]) || {};

      return {
        max,
        min,
        marks: {
          [min]: {
            label: min
          },
          [max]: {
            label: max
          }
        }
      };
    },
    sportList() {
      const filter =
        this.filterData &&
        this.filterData.find(i => {
          return i.code === 'PDP_END_USE';
        });
      return filter;
    },
    filterSideIsSticky() {
      return this.$store.state.filterSideIsSticky;
    }
  },
  watch: {
    rangeOption: {
      handler() {
        this.init();
      },
      deep: true
    },
    selectedList(val) {
      // 将数据传个神策的
      this.$emit('onSelected', val);
    }
  },
  mounted() {
    this.init();
    this.scrollEvent();
  },
  beforeDestroy() {
    const filter = document.querySelector('.page-plp_filter');
    filter && filter.removeEventListener('wheel', this.onWheel);
  },
  methods: {
    handleClickCollapse(code) {
      if (this.fold.includes(code)) {
        this.fold = this.fold.filter(str => str != code);
      } else {
        this.fold.push(code);
      }
    },
    handleEventStop() {
      console.log('我只是个阻止事件冒泡的默认行为');
    },
    init() {
      const { min, max } = this.rangeOption;
      if (min != max) {
        this.showPriceRange = true;
      }
      this.priceRange = [min, max];
    },
    onChange(data, item) {
      const code = ['SLIDER'].includes(item.type)
        ? item.code
        : item.code === 'CATEGORY'
        ? item.code
        : data.parentCode;
      if (item.code === 'PRICE') {
        this.$set(this.selectedData, code, []);
        this.selectedData[code].push(data);
      } else {
        const checkedData = this.selectedData[code];
        if (checkedData) {
          const index = checkedData.findIndex(i => {
            return i.code === data.code;
          });
          index > -1 ? checkedData.splice(index, 1) : this.selectedData[code].push(data);
        } else {
          this.$set(this.selectedData, code, [data]);
        }
      }
    },
    onChangeConfirm() {
      this.$emit('mergeOption', this.bindValue3, this.bindValue2, this.selectedData);

      this.handleViewResult();
      this.drawer = false;

      this.setFilterBarCeilingOption();
    },
    handleRemove(i) {
      const parentCode = i.attrCate === 'CATEGORY' ? 'CATEGORY' : i.parentCode;
      const data = this.selectedData[parentCode];

      const index = data.findIndex(c => c.code === i.code);
      index > -1 && data.splice(index, 1);
      const parentData = this.filterData.find(c => c.code === parentCode.toUpperCase());
      if (parentCode === 'PRICE') {
        this.priceRange = [this.rangeOption.min, this.rangeOption.max];
        if (!this.isMobile) {
          this.onFilter([this.priceRange], parentData);
          this.backToTop();
        } else {
          this.queryProductNum();
        }

        this.sliderKey++;
      } else if (!this.isMobile) {
        this.onFilter(data, parentData);
        this.backToTop();
      } else {
        this.queryProductNum();
      }
    },
    handleClearAll() {
      this.selectedData = {};
      this.priceRange = [this.rangeOption.min, this.rangeOption.max];
      this.sliderKey++;
      // 清空选中项
      this.bindValue = [];
      this.bindValue2 = [];
      this.bindValue3 = [];
      this.spuAttrList.forEach(item => {
        item.bindValue = [];
      });
      const { min, max } = this.rangeOption;
      this.priceRange = [min, max];
      if (!this.isMobile) {
        this.resetFilterData();
        this.$emit('mergeOption', this.bindValue3, this.bindValue2, this.selectedData);
        this.backToTop();
      } else {
        this.queryProductNum();
      }
      this.$emit('resetParentFilterOption');
      this.drawer = false;
      this.setFilterBarCeilingOption();
    },
    handleViewResult() {
      const selectedList = Object.keys(this.selectedData) || [];
      if (!selectedList.length) {
        this.resetFilterData();
      } else {
        selectedList.forEach(i => {
          const valueList = this.selectedData[i];
          const parentData = this.filterData.find(c => c.code === i.toUpperCase());
          this.onFilter(valueList, parentData);
        });
        // ---------------
        // const _this = this;
        // async function processAsyncTasks(tasks) {
        //   for (const i of tasks) {
        //     try {
        //       console.log('iiiii', i);
        //       const valueList = _this.selectedData[i];
        //       const parentData = _this.filterData.find(c => c.code === i.toUpperCase());
        //       console.log('handleViewResult', valueList, parentData);
        //       await _this.onFilter(valueList, parentData);
        //     } catch (error) {
        //       console.error('Error:', error);
        //     }
        //   }
        // }
        // processAsyncTasks(selectedList);
        // ----------------
        // const promises = selectedList.map(i => {
        //   console.log('iiiii', i);
        //   const valueList = this.selectedData[i];
        //   const parentData = this.filterData.find(c => c.code === i.toUpperCase());
        //   console.log('handleViewResult', valueList, parentData);

        //   return this.onFilter(valueList, parentData);
        // });
        // Promise.all(promises)
        //   .then(results => {
        //     // 所有的异步调用已经完成，结果存储在results数组中
        //     console.log('All operations completed:', results);
        //   })
        //   .catch(error => {
        //     // 处理错误
        //     console.error('Error:', error);
        //   });
      }
      this.backToTop();
    },
    async queryProductNum() {
      const categoryCodeList = this.selectedData.CATEGORY || [];
      const attrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SKUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });
      const spuAttrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SPUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });

      const sendData = {
        numberFilter: 'salePrice',
        categoryCodeList: categoryCodeList.map(i => i.code) || [],
        brandCodeList: [],
        fqList: [{ fq: 'ra', key: 'salePrice', value: this.priceRange.toString() }],
        attrList,
        // sortList: this.sortList,
        spuAttrList
      };

      this.loading = true;
      // 初始化

      const plp = ['home', 'LandingPage', 'LandingPage-all'].includes(this.$route.name)
        ? CatalogWcmProduct()
        : CatalogProduct();
      plp.init({
        categoryExtCode: this.$route.params.category,
        hasFilter: false,
        conditionKeyword: this.$route.query.searchWord || ''
      });
      const {
        pageInfo: { totalCount }
      } = await plp?.checkCondition(sendData);
      this.$emit('changeTotalCount', totalCount);
    },
    trackData(name) {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      const { list = [] } = data;
      const primary_category = list.length && list[0];
      const secondary_category = primary_category?.children?.length && primary_category.children[0];
      const third_category = secondary_category?.list?.length && secondary_category.list[0];
      this.$trackHelp.track('productScreen', {
        belong_page: '商品列表页',
        primary_category: primary_category?.categoryName,
        secondary_category: secondary_category?.name,
        third_category: third_category?.categoryName,
        list_name: name
      });
    },
    scrollEvent() {
      const filter = document.querySelector('.page-plp_filter');
      filter && filter.addEventListener('wheel', this.onWheel, false);
    },
    onWheel() {
      // e.preventDefault();
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      const filter = document.querySelector('.page-plp_filter');
      if (filter) {
        filter.style.pointerEvents = 'none';
        this.timer = setTimeout(() => {
          filter.style.pointerEvents = 'auto';
          this.timer = null;
        }, 500);
      }
    },
    backToTop() {
      // // 回到顶部
      // const $scroll = document.querySelector('.sp-wrapper-scroll');
      // const adContainer = document.querySelector('.ad-page-top');
      // const adHeight = adContainer ? adContainer.offsetHeight : 0;

      // $scroll && $scroll.scrollTo(0, adHeight);
      // setTimeout(() => {
      //   const leftContainer = document.querySelector('.page-plp_filter-side');
      //   const leftContainerParent = document.querySelector('.page-plp-left');
      //   if (leftContainer) {
      //     // leftContainer.style.position = 'relative';
      //     // leftContainer.style.bottom = '0px';

      //     // leftContainer.style.top = '0px';
      //     // leftContainer.style.height = 'auto';
      //     // leftContainerParent.style.display = 'block';
      //     // leftContainerParent.style.height = 'auto';
      //     leftContainerParent.classList.remove('flex');
      //     leftContainerParent.classList.remove('fixed');
      //     leftContainerParent.classList.remove('sticky');
      //     leftContainerParent.classList.add('relative');
      //     leftContainerParent.style.height = 'auto';
      //   }
      // }, 500);
      // scrollToTop();
      if (this.filterSideIsSticky) {
        // 筛选栏吸顶，滚动到筛选栏，筛选栏未吸顶，不做操作
        const $scroll = document.querySelector('html'); // 整个页面滚动至 筛选栏吸顶位置
        // 获取 top title 和 filterbar 元素
        const topTitleElement = this.isMobile
          ? document.querySelector('.mobile_header-layer')
          : document.querySelector('.gt-header');
        const topPlpElement = document.querySelector('.slot-page-plp-top'); // 筛选栏的title：xx拖鞋 xx件商品
        const topPlpElement2 = document.querySelector('.sp-swiper-container'); // 顶部slide图
        // 计算元素高度
        const topTitleHeight = topTitleElement?.offsetHeight || 0;
        const topPlpHeight = topPlpElement?.offsetHeight || 0;
        const topPlpHeight2 = topPlpElement2?.offsetHeight || 0;
        // 设置触发吸顶的位置
        const triggerPosition =
          (this.isMobile ? topTitleHeight : 12) + topPlpHeight + topPlpHeight2;
        $scroll && $scroll.scrollTo(0, triggerPosition);
      }
    },
    handleClose() {
      this.drawer = false;
    },
    changeCategory(data) {
      // if (data) {
      // this.$nextTick(() => {
      //   this.bindValue = data;
      //   const obj = this.categoryList.list[0].list.find(ele => {
      //     return ele.code === data;
      //   });
      //   this.$set(this.selectedData, 'CATEGORY', obj ? [obj] : []);
      // });
      // }
      // fix hint:弹框的产品分类筛选条件改为多选，并且不会联动到外面
      this.$set(this.selectedData, 'CATEGORY', []);
      data.forEach(ele => {
        // const filter = this.categoryList.list[0].list.find(c => {
        const filter = this.packedCategoryList().find(c => {
          return c.code === ele;
        });
        this.onChange(filter, this.categoryList);
      });
    },
    // changeSport(data) {
    //   this.$set(this.selectedData, this.sportList.code, []);
    //   data.forEach(ele => {
    //     const filter = this.sportList.list.find(c => {
    //       return c.code === ele;
    //     });
    //     this.onChange(filter, this.sportList);
    //   });
    // },
    // changeTag(data) {
    //   this.$set(this.selectedData, this.tagList.code, []);
    //   // TODO：不单是用code，用code的话是单选
    //   data.forEach(ele => {
    //     const filter = this.tagList.list.find(c => {
    //       return c.code === ele;
    //     });
    //     this.onChange(filter, this.tagList);
    //   });
    // },
    changeSpu(data, item) {
      this.$set(this.selectedData, item.code, []);
      // item.bindValue = data;
      this.$nextTick(() => {
        this.filterData.forEach(i => {
          if (i.attrCate === 'SPUATTR' && i.code === item.code) {
            i.bindValue = data;
          }
        });
      });
      data.forEach(ele => {
        const filter = item.list.find(c => {
          return c.code === ele;
        });
        this.onChange(filter, item);
      });
    },
    changeSex(data) {
      this.$set(this.selectedData, 'PDP_SEX', []);
      const result =
        this.filterData &&
        this.filterData.find(i => i.attrCate === 'SPUATTR' && i.code === 'PDP_SEX');
      data.forEach(ele => {
        const filter = result.list.find(c => {
          return c.code === ele;
        });
        this.onChange(filter, result);
      });
    },
    changeSize(data) {
      // this.$set(this.selectedData, this.sizeList.code, []);
      // data.forEach(ele => {
      //   const filter = this.sizeList.list.find(c => {
      //     return c.code === ele;
      //   });
      //   this.onChange(filter, this.sizeList);
      // });
      this.$set(this.selectedData, 'SIZE', []);
      const result =
        this.filterData && this.filterData.find(i => i.attrCate === 'SKUATTR' && i.code === 'SIZE');
      data.forEach(ele => {
        const filter = result.list.find(c => {
          return c.code === ele;
        });
        this.onChange(filter, result);
      });
    },
    clickFilterButton(sizeBindValue, selectedData) {
      // 合并尺寸数据
      this.bindValue = selectedData.CATEGORY
        ? selectedData.CATEGORY.map(ele => {
            return ele.code;
          })
        : [];
      this.bindValue3 = sizeBindValue || [];
      this.bindValue2 = selectedData.PDP_SEX
        ? selectedData.PDP_SEX.map(ele => {
            return ele.code;
          })
        : [];
      this.$set(this.selectedData, 'SIZE', selectedData.SIZE || []);
      this.$set(this.selectedData, 'PDP_SEX', selectedData.PDP_SEX || []);
      this.$set(this.selectedData, 'CATEGORY', selectedData.CATEGORY || []);
      this.isShowCategoryCollapse =
        this.unidirectionSelectedDataStatus ||
        (this.$route.name !== 'plpSearch' &&
          // (!this.categoryList.list[0].list.some(ele => this.selectedCodeList.includes(ele.code)) ||
          (!this.packedCategoryList().some(ele => this.selectedCodeList.includes(ele.code)) ||
            false));
    },

    observerScroll() {
      document.addEventListener('scroll', this.listenerScroll);
    },
    setFilterBarCeilingOption() {
      const _this = this;
      // 监听滚动事件，计算filterbar的吸顶样式
      this.observerScroll();
      // 设置filterbar和顶部title的padding长度
      if (!this.isMobile) {
        const viewportWidth = window.innerWidth;
        const filterBarElement = document.querySelector('.page-plp-left');
        let filterTopElement = document.querySelector('.slot-page-plp-top');

        const handleElement = (element, type) => {
          if (element) {
            if (type) {
              element.style.paddingLeft = '7.5%';
              element.style.paddingRight = '7.5%';
            } else {
              element.style.paddingLeft = (viewportWidth - 1440) / 2 + 'px';
              element.style.paddingRight = (viewportWidth - 1440) / 2 + 'px';
            }
          }
        };

        // Function to apply styles to elements
        const applyStyles = () => {
          if (viewportWidth < 1695) {
            handleElement(filterBarElement, true);
            handleElement(filterTopElement, true);
          } else {
            handleElement(filterBarElement, false);
            handleElement(filterTopElement, false);
          }
          _this.showFilterStyle = true;
        };

        // Function to check for element existence and apply styles
        const checkAndApplyStyles = () => {
          if (filterTopElement) {
            applyStyles();
          } else {
            // If the element is not found, set up a MutationObserver
            const observer = new MutationObserver(() => {
              filterTopElement = document.querySelector('.slot-page-plp-top'); // 加载渲染元素有时效性，加个元素监听
              if (filterTopElement) {
                // If the element is found, disconnect the observer and apply styles
                observer.disconnect();
                applyStyles();
              }
            });

            // Configure and start the observer
            observer.observe(document.body, { childList: true, subtree: true });
          }
        };

        checkAndApplyStyles();
      } else {
        _this.showFilterStyle = true;
      }
    },
    packedCategoryList() {
      let list = [];
      this.categoryList.list.forEach(ele => {
        list = list.concat(ele.list);
      });
      console.log('listab', list);
      return list;
    }
  }
};
</script>

<style lang="scss">
.body-plp-drawer {
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .el-drawer {
    width: 480px !important;
    padding: 40px 40px 88px 40px;
    &__header {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-family: PingFang SC;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-transform: capitalize;
      padding: 0;
    }
    .el-icon-close {
      font-size: 24px;
    }
  }
  .selected-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
    color: var(--font-color-primary);
    h3 {
      font-size: 16px;
    }
    .clear-all {
      cursor: pointer;
      text-decoration: underline;
      font-size: 12px;
    }
  }
  .size-list,
  .color-list {
    flex-wrap: wrap;
    display: flex;
    &_item {
      text-align: center;
      cursor: pointer;
    }
  }
  .color-collapse-item {
    margin-bottom: 20px;
  }
  .color-collapse-item,
  .size-collapse-item {
    .el-collapse-item__content {
      padding-bottom: 0px;
    }
  }
  .size-list {
    &_item {
      width: calc(33.3% - 16px);
      margin-right: 16px;
      border: 1px solid rgba(0, 0, 0, 0);
      border-radius: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32px;
      margin-bottom: 16px;
      &.active {
        border: 1px solid #151515;
      }
    }
  }
  .color-list {
    padding-right: 4px;
    &_item {
      width: 24px;
      height: 24px;
      border: 2px solid rgba(0, 0, 0, 0);
      border-radius: 100%;
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 2px;
      p {
        border-radius: 100%;
        width: 100%;
        height: 100%;
        &.white {
          border: 1px #979797 solid;
        }
      }
      &:nth-child(5) {
        margin-right: 0px;
      }
      &.active {
        border: 7px solid #f3f3f4 !important;
        padding: 0px !important;
      }
    }
  }
  .tag-list {
    &_item {
      padding: 22px 0px;
      border-top: 1px #f0f0f0 solid !important;
      color: #50505a;
      cursor: pointer;
    }
  }
  .category-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  .price-collapse-item {
    .el-collapse-item__content {
      padding-right: 0px;
    }
    .el-collapse-item__wrap {
      overflow: visible;
    }
    .gt-plp-filter__optiontypes-slider {
      padding-bottom: 25px;
      .el-slider__button-wrapper {
        z-index: 1;
      }
    }
    .el-slider__runway {
      height: 4px;
      .el-slider__bar {
        height: 4px;
      }
    }
    .price-select_input {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 2px;
      .input-number-container {
        position: relative;
        .prefix {
          position: absolute;
          height: 40px;

          left: 10px;
          display: flex;
          align-items: center;
          color: #5f5f5f;
          padding-left: 6px;
          z-index: 9;
        }
      }
      .gt-input.el-input-number {
        width: 78px;
        border-radius: 0px;
        .gt-input_number {
          border-radius: 0;
        }
        .el-input__inner {
          border: 1px #151515 solid;
          border-radius: 0px;
          text-align: left;
          padding-left: 27px;
        }

        &.el-input--prefix .el-input__inner {
          padding-left: 20px !important;
        }
      }
    }
    .price-input-button {
      width: 32px;
      height: 32px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      cursor: pointer;
      margin-left: 16px;
      i {
        font-weight: bold;
      }
    }
  }
  .el-collapse {
    border: none;
  }
  .el-collapse-item__wrap {
    border: none;
  }
  .el-drawer__header {
    margin-bottom: 28px;
  }
  .el-collapse-item__header {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    text-transform: capitalize;
    border: none;
    align-items: start;
    height: 46px;
  }
  .el-collapse-item__content {
    padding-bottom: 32px;
  }
  /* 隐藏滚动条本身，但保留滚动效果 */
  /* 仅适用于支持 WebKit 的浏览器 */

  /* 隐藏滚动条轨道 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  /* 隐藏滚动条的 thumb（拖动滑块） */
  ::-webkit-scrollbar-thumb {
    background: transparent; /* 使滑块透明 */
  }
  .price-item {
    display: flex;
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    text-transform: capitalize;
    border: none;
    align-items: start;
    height: 46px;
    .price-left {
      flex: 1;
    }
    .price-right {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-family: Neue Plak;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }
  .price-item-bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    color: var(--secondary-color-ua-cool-grey-02, #b4b4bf);
    text-align: center;
    font-family: Neue Plak;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 32px;
    .price-left {
    }
    .price-right {
    }
  }
  .el-slider .el-slider__runway .el-slider__button {
    border-color: var(--main-color-ua-red, #dc0019);
  }
  .el-slider__button {
    width: 24px;
    height: 24px;
    border: 3px solid;
  }
  .gt-plp-filter__optiontypes-slider {
    padding: 0px 15px 12px;
  }
  .color-list {
    display: flex;
    // justify-content: space-between;
    .color-list_item {
      width: 38px;
      height: 38px;
      border-radius: 100%;
      padding: 0px;
      padding: 7px;
      margin-right: calc((100% - 6 * 38px) / 5); /* 计算并设置右边距 */
      margin-bottom: 12px;
      border: 0px;
      position: relative;
    }
    .color-list_item:nth-of-type(6n) {
      margin-right: 0px;
    }
    .icon-check-line {
      font-size: 16px;
      width: 24px;
      height: 24px;
      color: white;
      position: absolute;
      top: -1px;
    }
  }
  .drawer-bottom {
    display: flex;
    width: 100%;
    height: 88px;
    align-items: center;
    gap: 12px;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    background: #fff;
    z-index: 9999;
    left: 0px;
    padding: 0 20px;
    border-top: 1px solid var(--line-color-line-grey-02, #eee);

    .db-reset {
      display: inline-block;
      width: calc((100% - 12px) / 2);
      margin-left: 0px;
    }
    .db-confirm {
      display: inline-block;
      width: calc((100% - 12px) / 2);
      margin-left: 0px;
    }
  }
  .el-drawer__body {
    padding-bottom: 72px;
    overflow-x: hidden;
  }
  .el-collapse-item__arrow {
    margin: 0 0 0 auto;
  }

  .el-collapse-item__wrap {
    display: block !important;
    transition: none !important;
  }
  .el-collapse-item__header {
    cursor: pointer !important; /* 禁用鼠标手型 */
    pointer-events: none !important; /* 禁用点击事件 */
  }
  div:has(> .el-collapse-item__header) {
    cursor: pointer;
  }
  .foldOneLine {
    max-height: 46px !important;
    overflow: hidden;
  }
  .foldOneLine2 .el-collapse-item__header i {
    transform: rotate(90deg) !important;
  }
  .foldOneLine3 {
    max-height: 50px !important;
    overflow: hidden;
  }
  .fold-multi {
    transition: all 0.3s;
    max-height: 500px;
  }
}
.page-plp_drawer-mobile {
  .el-drawer {
    width: 100% !important;
    padding: 24px 20px;
    .el-icon-close {
      font-size: 16px;
    }
  }
  .el-drawer__header {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .el-collapse-item__header {
    font-size: 12px;
    height: 38px;
  }
  .el-collapse-item__content {
    padding-bottom: 20px;
  }
  .price-item {
    font-size: 12px;
    height: 38px;
    .price-right {
      font-size: 12px;
    }
  }
  .price-item-bottom {
    font-size: 12px;
    margin-bottom: 20px;
  }
  .color-collapse-item {
    margin-bottom: 8px;
  }
  .el-drawer__body {
    padding-bottom: 140px;
  }
}
</style>
